export default __webpack_public_path__ + "media/images/react_icons/facebook_login-592e770f6ce367363f1480ec8b4f20e0.svg";